<template>
  <div class="guide">
    <van-popup v-model="visible" class="nx-full" style="background:transparent;">
      <div class="nx-full nx-relative" @click="$emit('update:visible',false)">
        <nx-image :is-oss="false" class="guide__icon" width="61px" height="75px" :src="require(`@/assets/images/guide.png`)" />
        <div class="guide__content nx-flex-column-center-center">
          <span>{{ tips }}</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: 'NxGuide',
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    tips: {
      type: [String],
      default: () => '点击在浏览器打开',
    },
  },
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.guide{
  &__content{
    font-size: 16px;
    color: #fff;
    background: transparent;
    position: absolute;
    top: 105px;
    right: 70px;
  }
  &__icon{
    position: absolute;
    top: 12px;
    right: 70px;
  }
}
</style>
